<template>
  <div class="games-page page-container">
    <section class="page-header">
      <h1>小游戏</h1>
      <p>工作之余，放松一下</p>
    </section>

    <!-- 品牌浅色提示带 -->
    <section class="intro-band">
      <i class="el-icon-trophy" />
      <p>精选休闲小游戏，无需下载即点即玩。适合工作间隙放松、打发碎片时间。</p>
    </section>

    <section class="game-section">
      <div class="media-section-header">
        <h2>全部游戏</h2>
        <span>共 {{ games.length }} 款</span>
      </div>
      <div class="media-grid">
        <article v-for="(game, index) in games" :key="game.id" class="media-card" @click="openGame(game.id)">
          <div :class="['media-tile', `tile-${index % 4 + 1}`]">
            <i :class="game.icon" />
          </div>
          <div class="media-body">
            <h3>{{ game.name }}</h3>
            <p>{{ game.description }}</p>
            <el-button type="primary" size="small" icon="el-icon-video-play">开始游戏</el-button>
          </div>
        </article>
      </div>
    </section>
  </div>
</template>

<script>
import { games } from '../config/games'

export default {
  name: 'MiniGamesPage',
  data() {
    return { games }
  },
  methods: {
    // 新开独立标签页运行游戏，避免嵌入列表页影响键位操作体验。
    openGame(id) {
      window.open(`${window.location.origin}/#/games/play/${id}`, '_blank')
    }
  }
}
</script>

<style scoped>
.games-page { padding-top: 72px; padding-bottom: 80px; }

/* 封面渐变四款循环（共用卡片结构见全局 media-* 类） */
.tile-1 { background: linear-gradient(135deg, var(--brand-soft) 0%, var(--surface-2) 100%); }
.tile-2 { background: linear-gradient(135deg, var(--surface-2) 0%, var(--surface-3) 100%); }
.tile-3 { background: linear-gradient(135deg, var(--surface-3) 0%, var(--brand-soft) 100%); }
.tile-4 { background: linear-gradient(135deg, var(--surface-2) 0%, var(--brand-soft) 100%); }

@media (max-width: 600px) {
  .games-page { padding-top: 40px; padding-bottom: 56px; }
}
</style>
